export default __webpack_public_path__ + "/dist/images/image00017.a1cbe3f2c1bd23ffc4ad98f61c6d7e9b.jpeg";